<script setup lang="ts">
import { ref } from 'vue'
import type { PropType } from 'vue'

interface QAItems {
    question: string
    answer: string
}

const props = defineProps({
    title: {
        type: String,
        default: '标题',
    },
    qAData: {
        type: Array as PropType<QAItems[]>,
        default: () => [],
    },
})

const foldArr = ref<boolean[]>(new Array(props.qAData.length).fill(false))

const toggleShow = (index: number) => {
    foldArr.value[index] = !foldArr.value[index]
}
</script>

<template>
    <div class="qa-part">
        <div class="title">{{ title }}</div>
        <div class="qa-container">
            <div
                v-for="(item, index) in qAData"
                :key="item.question"
                class="qa-item"
                @click="toggleShow(index)"
            >
                <div class="question">{{ item.question }}</div>
                <div
                    class="answer"
                    v-show="foldArr[index]"
                    v-html="item.answer"
                ></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
.qa-part {
    max-width: 800px;
    margin: 20px auto;

    .title {
        font-size: 3.75rem;
        font-weight: 500;
        margin-bottom: 50px;
        line-height: 1.2;
        color: #FFFFFF;
    }

    .qa-container {
        display: flex;
        flex-direction: column;
        row-gap: 30px;
        margin-bottom: 120px;
    }

    @media (max-width: 768px) {
        padding: 0 16px;

        .title {
            font-size: 2rem;
            margin-bottom: 30px;
        }

        .qa-container {
            row-gap: 20px;
            margin-bottom: 80px;
        }
    }

    @media (max-width: 480px) {
        .title {
            font-size: 1.5rem;
            margin-bottom: 24px;
        }

        .qa-container {
            row-gap: 16px;
            margin-bottom: 60px;
        }
    }
}

.qa-item {
    border-radius: 16px;
    padding: 20px;
    background-color: #22242d;
    cursor: pointer;
    user-select: none;

    .question {
        color: #f5f2f0;
        text-align: left;
        font-size: 1.125rem;
        font-weight: 500;
        margin-bottom: 15px;
    }

    .answer {
        font-size: 1rem;
        font-weight: 400;
        text-align: left;
        color: #FFFFFF;
    }

    @media (max-width: 768px) {
        border-radius: 12px;
        padding: 16px;

        .question {
            font-size: 1rem;
            margin-bottom: 12px;
        }

        .answer {
            font-size: 0.875rem;
        }
    }

    @media (max-width: 480px) {
        padding: 14px;

        .question {
            font-size: 0.9rem;
            margin-bottom: 10px;
        }

        .answer {
            font-size: 0.8rem;
        }
    }
}
</style>
